<clare-main-content-container [isNavNeeded]="false">
    <ng-container mainContent>
        <div class="userContainer">
            <clare-list-view
                [tableActionOptions]="tableActionOptions"
                [callState]="callState"
                title="All Staff"
                [columns]="columns"
                [source]="dataSource$ | async"
                (onFilter)="updateTableProperties($event)"
                (onEdit)="editUser($event)"
            ></clare-list-view>
        </div>
    </ng-container>
</clare-main-content-container>
